import { render, staticRenderFns } from "./v-gaps.vue?vue&type=template&id=06ee6903&scoped=true"
import script from "./v-gaps.vue?vue&type=script&lang=js"
export * from "./v-gaps.vue?vue&type=script&lang=js"
import style0 from "./v-gaps.vue?vue&type=style&index=0&id=06ee6903&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ee6903",
  null
  
)

export default component.exports